import script from "./User.vue?vue&type=script&setup=true&lang=js"
export * from "./User.vue?vue&type=script&setup=true&lang=js"

import "./User.vue?vue&type=style&index=0&id=0e3e86e6&lang=css"

const __exports__ = script;

export default __exports__